import { render, staticRenderFns } from "./roleManageDetail.vue?vue&type=template&id=f72d55c8&scoped=true&"
import script from "./roleManageDetail.vue?vue&type=script&lang=js&"
export * from "./roleManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72d55c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f72d55c8')) {
      api.createRecord('f72d55c8', component.options)
    } else {
      api.reload('f72d55c8', component.options)
    }
    module.hot.accept("./roleManageDetail.vue?vue&type=template&id=f72d55c8&scoped=true&", function () {
      api.rerender('f72d55c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/roleManage/roleManageDetail.vue"
export default component.exports